import { Content } from "./components/Content";

export function CountryPage() {
  return (
    <>
      <Content />
    </>
  );
}
